// extracted by mini-css-extract-plugin
export var resizer = "_cf-0";